import styles from './index.module.css';
import { Spin } from 'antd';
import React from 'react';

export const Loader = () => <Spin size="large" className={styles.spinContainer} />;
